export const DBorderMask = wcardinal.ui.DBorderMask;